import type { IssueId } from '../../../../../model/issue';
import { getStyle } from '../style-marshal';
import * as classNames from './classnames';

export { default as withRoadmapStyleMarshal } from './with-roadmap-style-marshal';
export { default } from './context';
export type { RoadmapStyleMarshalProps } from './context';
export type { CustomMarshal } from './types';
export type { Overrides as RoadmapStyleMarshalOverrides } from './provider';
export {
	default as RoadmapStyleMarshalProvider,
	RoadmapStyleMarshalProvider as RoadmapStyleMarshalComponent,
} from './provider';

export const getRowStyle = (id: IssueId, parentId?: IssueId) => {
	const rowClassName = classNames.row(id);
	const classes =
		parentId !== undefined ? [rowClassName, classNames.rowChild(parentId)] : rowClassName;

	return getStyle(classes);
};
